import {Component, Vue} from 'vue-property-decorator';
import {BusinessResidence} from "@/products-and-services/ProductsAndServicesModels";

@Component
export default class BusinessResidenceMixin extends Vue {
    get shouldShowResidentialItems(): boolean {
        return window.location.pathname.includes('residential');
    }

    get isResidential(): boolean {
        return window.location.pathname.includes('residential');
    }

    get isBusiness(): boolean {
        return window.location.pathname.includes('business');
    }

    setBusinessResidenceBasedOnCurrentPage() {
        if (this.shouldShowResidentialItems) {
            this.$store.commit('setBusinessResidence', BusinessResidence.Residence);
        } else {
            this.$store.commit('setBusinessResidence', BusinessResidence.Business);
        }
    }

    created() {
        if (this.$store.getters.isCartEmpty) {
            this.setBusinessResidenceBasedOnCurrentPage();
        }
    }
}